import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { AdminRoute } from '@/components/auth/AdminRoute';
import { Login } from '@/pages/Login';
import { Cotizacion } from '@/pages/Cotizacion';
import { Historial } from '@/pages/Historial';
import { Dashboard } from '@/pages/admin/Dashboard';
import { Usuarios } from '@/pages/admin/Usuarios';
import { Productos } from '@/pages/admin/Productos';
import { Inventario } from '@/pages/admin/Inventario';
import { TodasCotizaciones } from '@/pages/admin/TodasCotizaciones';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <Layout />,
        children: [
          { path: '/cotizacion', element: <Cotizacion /> },
          { path: '/historial', element: <Historial /> },
          {
            element: <AdminRoute />,
            children: [
              { path: '/admin/dashboard', element: <Dashboard /> },
              { path: '/admin/usuarios', element: <Usuarios /> },
              { path: '/admin/productos', element: <Productos /> },
              { path: '/admin/inventario', element: <Inventario /> },
              { path: '/admin/cotizaciones', element: <TodasCotizaciones /> },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/login" replace />,
  },
]);
